<!--  -->
<template>
  <div :class="['newdrawLots', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title titleName="趣味活动" :bcColor="'#fff'" :zIndex="1000"> </common-title>
    <section class="section">
      <div class="drawWarrp">
        <img
          class="chou"
          @click="drawBtn"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/funGame/startBtn.png"
          alt=""
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getRegisterSourceInfo, isminiLogin, loadMantisChat } from '@/utils/tools';
import { getParticipationdetailApi } from '@/api/archives/index';

export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    //如果已作答 跳到结果页
    async resultPage() {
      if (this.userInfo.id) {
        const res = await getParticipationdetailApi();
        if (res.code == 0) {
          let drawNum = this.calculateDrawNum(res);
          if (drawNum === 6) return;
          if (this.$root.$data.isApp) {
            const url = `${window.location.origin}/ark/fungameresult?drawNum=${drawNum}&hiddenNavigationBar=1`;
            this.$sendToApp('openNewWebView', { url }, false);
            return;
          }
          this.$router.replace({
            path: '/fungameresult',
            query: {
              drawNum,
            },
          });
          return;
        } else {
          this.$toast(res.msg);
        }
      }
    },

    calculateDrawNum(res) {
      let data = res.data;
      if (data === '棱镜追光者') {
        return 1;
      }
      if (data === '恒星追光者') {
        return 2;
      }
      if (data === '萤火追光者') {
        return 3;
      }
      if (data === '火炬追光者') {
        return 4;
      }
      if (data === '彗星追光者') {
        return 5;
      }
      if (data === '') {
        return 6;
      }
    },
    // 抽奖按钮
    async drawBtn() {
      if (!this.userInfo.id) {
        const { isApp = false } = this.$root.$data;
        if (isApp) {
          getRegisterSourceInfo(this, 'stresstest', 2, false);
        } else if (this.$root.whatEev === 'miniprogram') {
          let url = window.location.href;
          isminiLogin(url);
        } else {
          const { search } = window.location;
          const has = search !== '';
          const param = { has, redirect: '/fungame' };
          this.$router.push({ path: '/registrationLogin', query: param });
        }
      } else {
        if (this.$root.miniprogram) {
          const res = await getParticipationdetailApi();
          if (res.code == 0 && res.data !== '') {
            let drawNum = this.calculateDrawNum(res);
            this.$router.replace({
              path: '/fungameresult',
              query: {
                drawNum,
              },
            });
          } else {
            this.$router.push({ path: '/fungameanswer' });
          }
        } else {
          setTimeout(() => {
            this.$router.push({ path: '/fungameanswer' });
          }, 1000);
        }
      }
    },

    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
  },
  created() {
    loadMantisChat(this.userInfo);
    setTimeout(() => {
      if (!this.$root.miniprogram) {
        this.resultPage();
      }
    }, 100);
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.newdrawLots {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding-top: 100px;
  background: #000;

  &.inApp {
    padding-top: 0;
  }

  .section {
    position: relative;
    width: 100%;
    height: 1174px;
    background: url(https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/funGame/homebg.png)
      no-repeat;
    background-size: 100% 100%;

    .chou {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      width: 360px;
      height: 110px;
      margin: 0 auto;
      animation: breatheEffect 3s ease-in-out infinite;
    }
  }

  .share-btn {
    position: fixed;
    right: 36px;
    bottom: 20px;
    left: 36px;
    width: 678px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    background: #ff7f41;
    border-radius: 45px;
  }

  @keyframes breatheEffect {
    0% {
      transform: scale(1);
    }

    25% {
      transform: scale(1.05);
    }

    50% {
      transform: scale(1);
    }

    75% {
      transform: scale(1.05);
    }
  }
}
</style>
